
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.333 2.667a.667.667 0 00-.666.667v9.333a.667.667 0 00.666.667H6a.667.667 0 010 1.333H3.333a2 2 0 01-2-2V3.334a2 2 0 012-2H6a.667.667 0 010 1.333H3.333zM10.195 4.195c.26-.26.683-.26.943 0l3.333 3.334c.26.26.26.682 0 .942l-3.333 3.334a.667.667 0 11-.943-.943L13.057 8l-2.862-2.862a.667.667 0 010-.943z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.333 8c0-.368.299-.666.667-.666h8a.667.667 0 110 1.333H6a.667.667 0 01-.667-.666z"}})])
          )
        }
      }
    